module.exports = __webpack_public_path__ + "img/button__portfolio__mobile.310697b6.svg";